export default __webpack_public_path__ + "static/media/tada.5ab6f4b1.mp3";